function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M24.286 15.714a4.286 4.286 0 1 0 0-8.571 4.286 4.286 0 0 0 0 8.571zM18.57 11.43a5.714 5.714 0 1 1 11.429 0 5.714 5.714 0 0 1-11.429 0zM5.714 15.714a4.286 4.286 0 1 0 0-8.571 4.286 4.286 0 0 0 0 8.571zM0 11.43a5.714 5.714 0 1 1 11.429 0 5.714 5.714 0 0 1-11.429 0z"
}), React.createElement("path", {
  d: "M5.13 12.707a.714.714 0 0 1-.595-1.11L9.47 4.155a.714.714 0 0 1 .565-.319l9.87-.413a.714.714 0 0 1 .635 1.093l-4.935 7.857a.714.714 0 0 1-.605.335H5.13zm9.475-1.429l4.003-6.372-8.15.341-3.998 6.031h8.145z"
}), React.createElement("ellipse", {
  cx: 14.383,
  cy: 11.372,
  rx: 2.262,
  ry: 2.274
}), React.createElement("path", {
  d: "M14.971 10.967L9.42 2.903a.714.714 0 0 0-1.176.81l5.552 8.064a.714.714 0 1 0 1.176-.81z"
}), React.createElement("path", {
  d: "M8.94 2.143H5.237a.714.714 0 0 0 0 1.428H8.94a.714.714 0 1 0 0-1.428zM24.865 11.003L18.49.458a.714.714 0 0 0-1.222.739l6.374 10.545a.714.714 0 0 0 1.223-.74z"
}), React.createElement("path", {
  d: "M17.673.119H14.59a.714.714 0 0 0 0 1.429h3.084a.714.714 0 0 0 0-1.429z"
}));

var SvgVehicleBicycle = function SvgVehicleBicycle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicleBicycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-bicycle.437b6687.svg";
export { ForwardRef as ReactComponent };